import {createSlice} from "@reduxjs/toolkit";

const blogSlice = createSlice({
    name: 'blog',
    initialState: {
        posts: [],
        post: {
            content:'',
            title:'',
            description: '',
        },
        meta: {
            current_page: 1,
            per_page: 12,
            total: 0
        }
    },
    reducers: {
        setPosts: (state, action) => {
            state.posts = action.payload;
        },
        setPost: (state, action) => {
            state.post = action.payload;
        },
        setBlogsMeta: (state, action) => {
            state.meta = action.payload;
        },
    }
})

export const {
    setPosts,
    setPost,
    setBlogsMeta
} = blogSlice.actions

export const getPosts = (state) => state.blogs.posts;
export const getPost = (state) => state.blogs.post;
export const getBlogsMeta = (state) => state.blogs.meta;


export default blogSlice.reducer;